import { render } from "./AboutTab5.vue?vue&type=template&id=dbc30e46"
const script = {}

import "./AboutTab5.vue?vue&type=style&index=0&id=dbc30e46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__